import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import IconButton from '@mui/material/IconButton';
import clxs from 'classnames';

const useStyles = makeStyles(
  (theme: Theme) => ({
    indicators: {
      width: '100%',
      textAlign: 'center',
    },
    indicator: {
      cursor: 'pointer',
      transition: '200ms',
      paddingRight: 5,
      color: '#fffff',
      '&:hover': {
        color: '#1f1f1f',
      },
      '&:active': {
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    indicatorIcon: {
      fontSize: '10px',
    },
    active: {
      color: 'rgba(255, 255, 255, 0.5)',
    },
    hide: {
      visibility: 'hidden',
    },
  }),
  { name: 'CarouselIndicator' },
);

interface IndicatorsProps {
  active: number;
  length: number;
  className?: string;
  press: (index: number) => void;
}

const Indicators: React.FC<IndicatorsProps> = (props: any) => {
  const classes = useStyles();

  let indicators = [];
  for (let i = 0; i < props.length; i++) {
    const item = (
      <IconButton
        key={i}
        className={clxs(classes.indicator, i === props.active ? classes.active : null)}
        onClick={() => {
          props.press(i);
        }}
        size="small"
      >
        <FiberManualRecordIcon className={classes.indicatorIcon} />
      </IconButton>
    );

    indicators.push(item);
  }
  // Hide the indicator for a single item...
  // if (props.length <= 1) indicators.splice(0, indicators.length);

  return <div className={clxs(classes.indicators, props.className, props.length <= 1 ? classes.hide : null)}>{indicators}</div>;
};

export default Indicators;
